import React from "react";
import { Route, Routes, useParams } from "react-router-dom";

import { ProgramType } from "shared/enums/ProgramType";
import { MyExpRoute } from "apps/myExperience/routes/types";
import ProgramHeader from "shared/components/programHeader";
import { useAssociatedProgramWorkflowService } from "./service";
import { ProgramStatusType } from "shared/types/ProgramStatusType";
import { ActivityListForActivityAdmin } from "../../profile/associated";
import ShortlistParticipantsForActivityMyExperience from "../../shortlist";
import MoreTimeslots from "shared/components/activity/list/components/moreTimeslots";
import ActivityDetailsServiceProvider from "shared/components/activity/details/context";
import ShortlistParticipantsInActivityTable from "apps/console/modules/program/workflow/associateProgram/shortlist/components/table";
import ActivityAgendaScheduleListing from "./agenda/list";
import { ActivityAgendaParticipationsForMyExperience } from "./agenda/details";
import ActivityAgendaListingForMarkAttendanceInMyExperience from "./attendance/list";
import ActivityParticipationMarkAttendanceInMyExperience from "./attendance/detail";
import SendCalendarInviteToParticipants from "./invitesSent/list/components/sendCalendarInvite";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";

export default function AssociatedProgramWorkFlow() {
  const service = useAssociatedProgramWorkflowService();
  return (
    <React.Fragment>
      <ProgramHeader
        programDetails={{
          programType: ProgramType.ASSOCIATED_PROGRAM,
          programStatus: service.programStatus as ProgramStatusType,
          skippedTimelineStages: service.skippedTimelineStages
        }}
      />
      <Routes>
        <Route path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_ACTIVITIES.path} element={<ActivityListForActivityAdmin />}>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_ACTIVITIES.DETAILS.path}
            element={<ActivityDetailsServiceProvider />}
          />
          <Route path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_ACTIVITIES.TIMESLOTS.path} element={<MoreTimeslots />} />
        </Route>
        <Route
          path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_SHORTLIST.path}
          element={<ShortlistParticipantsForActivityMyExperience />}>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_SHORTLIST.DETAILS.path}
            element={<ShortlistParticipantsInActivityTable />}></Route>
        </Route>
        <Route path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_SCHEDULE.path} element={<ActivityAgendaScheduleListing />}>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_SCHEDULE.DETAILS.path}
            element={<ActivityAgendaParticipationsForMyExperience />}></Route>
        </Route>

        <Route
          path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.path}
          element={<ActivityAgendaListingForMarkAttendanceInMyExperience />}>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.invite.path}
            element={<GoBack />}></Route>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.manage.path}
            element={<GoBack />}></Route>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.manageAgendaId.path}
            element={<ActivityAgendaParticipationsForMyExperience />}></Route>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.inviteWithAgendaId.path}
            element={<SendCalendarInviteToParticipants />}></Route>
          <Route
            path={MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.path}
            element={<ActivityParticipationMarkAttendanceInMyExperience />}></Route>
        </Route>
      </Routes>
    </React.Fragment>
  );
}

function GoBack() {
  const { agendaId = "" } = useParams();
  const { navigateToPreviousPath } = useNavigateWrapper();
  React.useEffect(() => {
    if (!agendaId) {
      navigateToPreviousPath();
    }
  }, [agendaId, navigateToPreviousPath]);

  return null;
}
